export function initMedia() {
    return [...document.querySelectorAll('.b-media:not(.-initialized)')].map(el => new Media(el));
}

export class Media {
    _dom = {};

    constructor(el) {
        if (!el) return;

        this._dom.el = el;
        this._dom.el.classList.add('-initialiazed');
        this._dom.playBtn = el.querySelector(".b-media__playbutton");
        this._dom.mediaFull = el.querySelector(".b-media .c-mediafull")
        this._dom.mediaImage = el.querySelector(".b-media__image")
        this._dom.iframe = el.querySelector(".c-mediafull__inner.-iframe"); // iframe element

        this.init();
    }

    init() {

        if (this._dom.mediaFull) {
            if (this._dom.playBtn) {
                this.addPlayButtonClickListener();
            }
        }
    }

    addPlayButtonClickListener() {
        this._dom.playBtn.addEventListener('click', () => {
            this._dom.mediaFull.style.display = 'flex';

            this._dom.playBtn.style.display = 'none';

            // Scroll media (video or iframe) into the viewport
            const mediaElement = this._dom.iframe;
            if (mediaElement) {
                // Check if it's a video element or an iframe and play accordingly
                if (this._dom.video) {
                    // Ensure the video element is available and play it
                    this._dom.video.play().catch((error) => {
                        console.error('Error attempting to play video:', error);
                    });
                } else if (this._dom.iframe) {
                    const iframe = this._dom.iframe.querySelector('iframe');
                    if (iframe) {
                        // Play the YouTube video using postMessage
                        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

                        if (this._dom.mediaImage) {
                            this._dom.mediaImage.style.display = 'none';
                        }
                    }
                }
            }
        });
    }
}